var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-container" },
    [
      _c(
        "nav",
        { staticClass: "row mb-3" },
        _vm._l(_vm.LevelFilters, function(filter, index) {
          return _c(
            "div",
            {
              staticClass: "col",
              on: {
                click: function($event) {
                  _vm.toggleFilter(index)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "btn btn-sm",
                  class: [filter.button, filter.active ? "active" : ""]
                },
                [
                  _c("div", { staticClass: "d-flex  align-items-center " }, [
                    _c("span", [_vm._v(_vm._s(index))]),
                    _vm._v(" "),
                    !_vm.unknown_totals
                      ? _c("span", [_vm._v("(" + _vm._s(filter.total) + ")")])
                      : _vm._e()
                  ])
                ]
              )
            ]
          )
        })
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-3" }, [
        _c("section", { staticClass: "col-12 col-md-6" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body mt-3" }, [
              _c("form", {}, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-block d-md-flex justify-content-md-between align-items-center"
                  },
                  [
                    _c("div", { staticClass: "md-form mb-0" }, [
                      _c("i", { staticClass: "fa prefix fa-calendar" }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.start_date,
                            expression: "start_date"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "filter_date", type: "date" },
                        domProps: { value: _vm.start_date },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.start_date = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "active",
                          attrs: { for: "filter_date" }
                        },
                        [_vm._v("From")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "md-form mb-0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.page_length,
                            expression: "page_length"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "page_length", type: "number" },
                        domProps: { value: _vm.page_length },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.page_length = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "page_length" } }, [
                        _vm._v("# results")
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-block d-md-flex justify-content-md-between align-items-center"
                  },
                  [
                    _c("div", { staticClass: "form-check pl-0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.uses_client,
                            expression: "uses_client"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: { id: "client_connection", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.uses_client)
                            ? _vm._i(_vm.uses_client, null) > -1
                            : _vm.uses_client
                        },
                        on: {
                          click: function($event) {
                            _vm.resetTotals()
                          },
                          change: function($event) {
                            var $$a = _vm.uses_client,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.uses_client = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.uses_client = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.uses_client = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: "client_connection" }
                        },
                        [
                          _vm._v(
                            "Use client's\n                                    connection"
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "btn btn-primary",
                        class: _vm.loading ? "disabled" : "",
                        on: {
                          click: function($event) {
                            _vm.newSearch()
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("search")
                        ])
                      ]
                    )
                  ]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-6" }, [
          _c("div", { staticClass: "card " }, [
            _c("div", { staticClass: "card-body " }, [
              _vm.last_search.uses_client
                ? _c("h4", { staticClass: "h4-responsive" }, [
                    _vm._v("Results - Client connection")
                  ])
                : _c("h4", { staticClass: "h4-responsive" }, [
                    _vm._v("Results")
                  ]),
              _vm._v(" "),
              _c("div", { staticClass: "py-2 " }, [
                _vm._v("Levels: " + _vm._s(_vm.last_search.filter_levels))
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "py-2 d-flex justify-content-between align-items-center "
                },
                [
                  _c("div", { staticClass: "d-inline-block" }, [
                    _c("span", { staticClass: "bold mr-3" }, [_vm._v("Date:")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.formatDate(_vm.last_search.start_date)) +
                          "\n                        "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-inline-block" }, [
                    _c("span", { staticClass: "bold mr-3" }, [
                      _vm._v("Total:")
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.total) +
                          "\n                        "
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "py-2 d-flex justify-content-between align-items-center "
                },
                [
                  _c("div", { staticClass: "d-inline-block" }, [
                    _c("span", { staticClass: "bold mr-3" }, [
                      _vm._v("Pages:")
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.last_search.page_length) +
                          "\n                        "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-inline-block" }, [
                    _c("span", { staticClass: "bold mr-3" }, [
                      _vm._v("Current:")
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.last_search.page) +
                          "\n                        "
                      )
                    ])
                  ])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "text-center" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        !_vm.loading && _vm.Logs.length > 0
          ? _c(
              "div",
              [
                _vm._l(_vm.Logs, function(log) {
                  return [
                    _c("div", { staticClass: "card mb-2" }, [
                      _c("div", { staticClass: "card-body mb-3 pb-1" }, [
                        _c("div", {}, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "mx-0 mt-0 cursor-pointer btn d-flex justify-content-between align-items-center ",
                              class: [
                                {
                                  active:
                                    _vm.loaded_log.loaded &&
                                    (_vm.Logs.length > 0 &&
                                      _vm.Logs.length < _vm.total) &&
                                    _vm.loaded_log.data.log.id == log.id
                                },
                                _vm.LevelFilters[log.level].background
                              ],
                              on: {
                                click: function($event) {
                                  _vm.loadSingle(log.id)
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "pr-3" }, [
                                _vm._v(_vm._s(log.id))
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "px-3 d-block d-md-none" },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.formatDate(log.created_at, "short")
                                      ) +
                                      "\n                                    "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "px-3 d-none d-md-block" },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.formatDate(log.created_at, "long")
                                      ) +
                                      "\n                                    "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  class: [
                                    {
                                      disabled: _vm.loading
                                    },
                                    _vm.LevelFilters[log.level].text
                                  ]
                                },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(log.level) +
                                      "\n                                "
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        !(
                          _vm.loaded_log.loaded &&
                          (_vm.Logs.length > 0 &&
                            _vm.Logs.length < _vm.total) &&
                          _vm.loaded_log.data.log.id == log.id
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "text-truncate",
                                attrs: { title: log.message }
                              },
                              [_c("code", [_vm._v(_vm._s(log.message))])]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.loaded_log.loaded &&
                      (_vm.Logs.length > 0 && _vm.Logs.length < _vm.total) &&
                      _vm.loaded_log.data.log.id == log.id
                        ? _c("div", { staticClass: "card-body mt-0 pt-1" }, [
                            _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "p-2 mb-2 color-block elegant-color"
                                },
                                [
                                  _c("code", {}, [
                                    _vm._v(
                                      "<" +
                                        _vm._s(
                                          _vm.loaded_log.data.log.message
                                        ) +
                                        ">"
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "list-group " }, [
                                _c("div", { staticClass: "list-group-item" }, [
                                  _c(
                                    "div",
                                    { staticClass: "small font-weight-light" },
                                    [_vm._v("Route:")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {}, [
                                    _vm._v(
                                      _vm._s(_vm.loaded_log.data.log.route)
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "list-group-item" }, [
                                  _c(
                                    "div",
                                    { staticClass: "small font-weight-light" },
                                    [_vm._v("Controller - Action:")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {}, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.loaded_log.data.log.controller
                                      ) +
                                        " @\n                                        " +
                                        _vm._s(_vm.loaded_log.data.log.action) +
                                        "\n                                    "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "list-group-item" }, [
                                  _c(
                                    "div",
                                    { staticClass: "small font-weight-light" },
                                    [_vm._v("File - Line:")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {}, [
                                    _vm._v(
                                      _vm._s(_vm.loaded_log.data.log.file) +
                                        " - " +
                                        _vm._s(_vm.loaded_log.data.log.line) +
                                        "\n                                    "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "details",
                                  { staticClass: "list-group-item" },
                                  [
                                    _c("summary", [_vm._v("User")]),
                                    _vm._v(" "),
                                    _vm.loaded_log.data.user == null
                                      ? _c("div", [_vm._v("null")])
                                      : _c("div", [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table table-sm table-responsive"
                                            },
                                            [
                                              _c("thead", [
                                                _c("tr", [
                                                  _c("th", [
                                                    _vm._v("Property")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("th", [_vm._v("Value")])
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "tbody",
                                                _vm._l(
                                                  _vm.loaded_log.data.user,
                                                  function(value, key) {
                                                    return _c("tr", [
                                                      _c("td", [
                                                        _vm._v(_vm._s(key))
                                                      ]),
                                                      _vm._v(" "),
                                                      key === "roles"
                                                        ? _c(
                                                            "td",
                                                            _vm._l(
                                                              value,
                                                              function(role) {
                                                                return _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "badge badge-sm badge-info"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        role.slug
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            )
                                                          )
                                                        : _c("td", [
                                                            _vm._v(
                                                              _vm._s(value)
                                                            )
                                                          ])
                                                    ])
                                                  }
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "details",
                                  { staticClass: "list-group-item" },
                                  [
                                    _c("summary", [
                                      _vm._v(
                                        "\n                                        Trace\n                                    "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.loaded_log.data.log.trace == null
                                      ? _c("div", [_vm._v("null")])
                                      : _c("div", [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table table-sm table-responsive"
                                            },
                                            [
                                              _c("thead", [
                                                _c("tr", [
                                                  _c("th", [_vm._v("File")]),
                                                  _vm._v(" "),
                                                  _c("th", [_vm._v("Line")]),
                                                  _vm._v(" "),
                                                  _c("th", [_vm._v("Class")]),
                                                  _vm._v(" "),
                                                  _c("th", [
                                                    _vm._v("Function")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("th", [_vm._v("Args")])
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "tbody",
                                                _vm._l(
                                                  _vm.loaded_log.data.log.trace,
                                                  function(_trace, index) {
                                                    return _c("tr", [
                                                      _c("td", [
                                                        _vm._v(
                                                          _vm._s(_trace.file)
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v(
                                                          _vm._s(_trace.line)
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v(
                                                          _vm._s(_trace.class)
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _trace.function
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-sm btn-info",
                                                            attrs: {
                                                              "data-toggle":
                                                                "collapse",
                                                              "data-target":
                                                                "#args_" +
                                                                index,
                                                              "aria-expanded":
                                                                "false",
                                                              "aria-controls":
                                                                "args_" + index
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-eye"
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "collapse",
                                                            attrs: {
                                                              id:
                                                                "args_" + index
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _trace.args
                                                                ) +
                                                                "\n                                                    "
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    ])
                                                  }
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.loaded_log.data.log.context == null
                                  ? _c(
                                      "div",
                                      { staticClass: "list-group-item" },
                                      [
                                        _vm._v(
                                          "\n                                    No context\n                                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "details",
                                  { staticClass: "list-group-item" },
                                  [
                                    _c("summary", [_vm._v("Context")]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "collapse",
                                        attrs: { id: "context_info" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "table table-sm table-responsive"
                                          },
                                          [
                                            _c("div", [
                                              _c("div", [
                                                _c("div", [_vm._v("Property")]),
                                                _vm._v(" "),
                                                _c("div", [_vm._v("Value")])
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              _vm._l(
                                                _vm.loaded_log.data.log.context,
                                                function(value, key) {
                                                  return _c("div", [
                                                    _c("div", [
                                                      _vm._v(_vm._s(key))
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("div", [
                                                      _vm._v(_vm._s(value))
                                                    ])
                                                  ])
                                                }
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "details",
                                  { staticClass: "list-group-item" },
                                  [
                                    _c("summary", [_vm._v("Extra")]),
                                    _vm._v(" "),
                                    _vm.loaded_log.data.log.extra == null
                                      ? _c("div", [_vm._v("null")])
                                      : _c("div", [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table table-sm table-responsive"
                                            },
                                            [
                                              _c("thead", [
                                                _c("tr", [
                                                  _c("th", [
                                                    _vm._v("Property")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("th", [_vm._v("Value")])
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "tbody",
                                                _vm._l(
                                                  _vm.loaded_log.data.log.extra,
                                                  function(value, key) {
                                                    return _c("tr", [
                                                      _c("td", [
                                                        _vm._v(_vm._s(key))
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v(_vm._s(value))
                                                      ])
                                                    ])
                                                  }
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                  ]
                                )
                              ])
                            ])
                          ])
                        : _vm._e()
                    ])
                  ]
                })
              ],
              2
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        !_vm.loading
          ? _c("div", { staticClass: "text-center" }, [
              _vm.Logs.length > 0 && _vm.Logs.length < _vm.total
                ? _c(
                    "a",
                    {
                      staticClass: "btn btn-sm btn-info",
                      on: {
                        click: function($event) {
                          _vm.page++
                          _vm.searchLogs()
                        }
                      }
                    },
                    [_vm._v("MORE")]
                  )
                : _vm.Logs.length > 0
                  ? _c("span", [_vm._v("No more results")])
                  : _c("span", [_vm._v("No results found")])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loader fs2" }, [
      _c("span", [_vm._v("{")]),
      _c("span", [_vm._v("}")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fa11add", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fa11add","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/pages/logs/LogSystemDisplay.vue
// module id = 404
// module chunks = 0